export const DEFAULT_SNACKBAR_DURATION_MS = 5000;
export const SUCCESS_SNACKBAR_DURATION_MS = 2000;
